module.exports = __webpack_public_path__ + "img/image-3.5915151a.svg";